import React from 'react';
import { Link } from 'react-router-dom';
import { SITE, GAMES } from '../data/servers';
import usePrices from '../hooks/usePrices';
import { PAGES, gamePath, serverPath, gameLabel } from './routes';

const Column = ({ title, titleTo, children }) => (
  <div>
    <h2 className="text-white text-sm sm:text-base font-semibold mb-2 sm:mb-3">
      {titleTo ? <Link to={titleTo} className="hover:text-yellow-400">{title}</Link> : title}
    </h2>
    <ul className="space-y-1.5 text-xs sm:text-sm">{children}</ul>
  </div>
);

const Item = ({ to, children }) => (
  <li><Link to={to} className="text-gray-400 hover:text-yellow-400">{children}</Link></li>
);

export default function SiteFooter() {
  const { servers } = usePrices();
  return (
    <footer className="bg-black border-t border-gray-800 pt-8 sm:pt-12 pb-20 sm:pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <Link to="/" className="inline-flex items-center gap-2 mb-6 sm:mb-8">
          <img src="/logo512.png" alt="AV Kamas" className="w-8 h-8 rounded-full" />
          <span className="text-lg font-bold tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-600">
            AV <span className="text-white">KAMAS</span>
          </span>
        </Link>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-x-4 gap-y-6 sm:gap-8 mb-6 sm:mb-10">
          <Column title="Services">
            <Item to={PAGES.buy}>Acheter des Kamas</Item>
            <Item to={PAGES.sell}>Vendre des Kamas</Item>
            <Item to={PAGES.prices}>Prix des Kamas</Item>
            <Item to={PAGES.comparison}>Comparatif TryAndJudge</Item>
          </Column>
          <Column title="Maroc">
            <Item to={PAGES.buyGuide}>Achat Kamas Maroc</Item>
            <Item to={PAGES.sellGuide}>Vente Kamas Maroc</Item>
            <Item to={PAGES.dofusMaroc}>Dofus Maroc</Item>
            <Item to={PAGES.servers}>Serveurs Dofus</Item>
            <Item to={PAGES.articles}>Articles</Item>
            <Item to={PAGES.faq}>FAQ</Item>
          </Column>
          {GAMES.map(game => (
            <Column key={game} title={`Kamas ${gameLabel(game)}`} titleTo={gamePath(game)}>
              {servers.filter(s => s.game === game).map(s => (
                <Item key={s.slug} to={serverPath(s)}>Kamas {s.name}</Item>
              ))}
            </Column>
          ))}
          <Column title="Mon compte">
            <Item to="/register">Créer un compte</Item>
            <Item to="/login">Connexion</Item>
            <Item to="/order-history">Mes commandes</Item>
            <Item to={PAGES.terms}>Conditions d'utilisation</Item>
            <Item to={PAGES.privacy}>Politique de confidentialité</Item>
            <li><a href={`mailto:${SITE.email}`} className="text-gray-400 hover:text-yellow-400 break-all">{SITE.email}</a></li>
          </Column>
        </div>
        <p className="text-gray-500 text-xs sm:text-sm text-center border-t border-gray-800 pt-4 sm:pt-6 leading-relaxed">
          © {new Date().getFullYear()} AV Kamas · achatventekamas.com · Achat Kamas et vente Kamas au Maroc pour Dofus, Dofus Rétro et Dofus Touch.
          <br />
          Dofus est une marque d'Ankama. AV Kamas est un service indépendant, non affilié à Ankama.
        </p>
      </div>
    </footer>
  );
}
